<template>
    <EditModal
        id="singpauseMitglieder"
        title="SingPause - Singleiter"
        size="xl"
        button-text="Speichern"
        :busy="busy"
        scrollable
        @ok="dataProvide"
    >
        <b-tabs pills card vertical>
            <template v-slot:tabs-start>
                <SchoolYearSwitcher class="mb-2" />
            </template>
            <b-tab title="Betreute Klassen" active
                ><SingPauseMitgliederKlassen
                    :id="id"
                    :schools="schools"
                    :refresh="refresh"
                    @update="updateData('klassen', ...arguments)"
            /></b-tab>
            <b-tab title="Schulpersonal"
                ><SingPauseMitgliederContacts
                    :id="id"
                    :schools="schools"
                    :refresh="refresh"
                    :validation="validation"
                    @update="updateData('contacts', ...arguments)"
            /></b-tab>
        </b-tabs>
    </EditModal>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import EditModal from "@/components/EditModal/EditModal";
import Toaster from "@/mixins/Toaster/Toaster";
import SingPause from "@/mixins/SingPause/SingPause";
import SingPauseMitgliederKlassen from "@/components/SingPauseMitglieder/SingPauseMitgliederKlassen";
import SingPauseMitgliederContacts from "@/components/SingPauseMitglieder/SingPauseMitgliederContacts";
import SchoolYearSwitcher from "@/components/SchoolYearSwitcher/SchoolYearSwitcher";

const SingPauseApi = ApiFactory.get("singpause");

export default {
    name: "SingPauseMitgliederModal",
    components: {
        EditModal,
        SingPauseMitgliederKlassen,
        SingPauseMitgliederContacts,
        SchoolYearSwitcher
    },
    mixins: [Toaster, SingPause],
    props: ["id"],
    data() {
        return {
            api: SingPauseApi,
            busy: false,
            schools: {
                data: [],
                busy: false
            },
            validation: null,
            refresh: true,
            klassen: [],
            contacts: [],
            konzerte: []
        };
    },
    mounted() {
        this.fetchSchools();
    },
    methods: {
        async dataProvide(evt) {
            evt.preventDefault();
            this.busy = true;
            const responseKlassen = await SingPauseApi.putKlassen(
                this.id,
                this.klassen,
                this.selectedSchoolYear
            );
            const responseContacts = await SingPauseApi.putContacts(
                this.id,
                this.contacts,
                this.selectedSchoolYear
            );
            if (responseContacts.ok && responseKlassen.ok) {
                // this.dataCancel();
                // this.$root.$emit("bv::hide::modal", "singpauseMitglieder");
                this.makeToast(
                    "Erfolgreich gespeichert",
                    "Die Änderungen wurden erfolgreich in der Datenbank gespeichert"
                );
                this.refresh = !this.refresh;
                this.validation = null;
            } else if (
                !responseContacts.ok &&
                responseContacts.json.validation
            ) {
                this.validation = responseContacts.json.validation;
            }
            this.busy = false;
        },
        dataCancel() {
            this.klassen = [];
            this.contacts = [];
            this.konzerte = [];
        },
        updateData(identifier, data) {
            this.validation = null;
            this[identifier] = data;
        }
    }
};
</script>
